export const XBIT_RELAY_WITHDRAWALS_PERMISSION_RESOURCE = 'xbit-relay:withdrawals';
export const XBIT_RELAY_WITHDRAWALS_READ_ACTION = 'read';
export const XBIT_RELAY_WITHDRAWALS_APPROVE_ACTION = 'approve';
export const XBIT_RELAY_WITHDRAWALS_REJECT_ACTION = 'reject';
export const XBIT_RELAY_WITHDRAWALS_RETRY_FAILED_ACTION = 'retry-failed';
export const XBIT_RELAY_WITHDRAWALS_CANCEL_FAILED_ACTION = 'cancel-failed';
export const XBIT_RELAY_WITHDRAWALS_MARK_DONE_ACTION = 'mark-done';
export const XBIT_RELAY_WITHDRAWALS_EXPORT_ACTION = 'export';

export const FAILED_ACTION_ELIGIBLE_PROVIDERS = ['INTERNAL_PERPETUAL', 'TAP_TRADING'] as const;

export const DEFAULT_WITHDRAWALS_PROVIDER = 'INTERNAL_PERPETUAL';

export const WITHDRAWAL_STATUSES = [
  'Pending',
  'Reviewing',
  'PendingAdminApproval',
  'Broadcasting',
  'Executing',
  'Confirming',
  'Completed',
  'Rejected',
  'Failed',
] as const;

export const WITHDRAWAL_PROVIDERS = [
  'PERPETUAL',
  'INTERNAL_PERPETUAL',
  'TAP_TRADING',
] as const;
